import { RootState } from '../store';

/**
 * Pass through the state
 *
 * @param state
 */
export const selectState = (state: RootState) => state;
